import {jsonMember, jsonObject} from "typedjson";
import {DxNavigationTreeNodeDataProvider} from "../../dx-navigation/domain/navigator/dx-navigation-tree-node-data-provider";


/** Элемент навигационного меню. */
@jsonObject
export class PitNavigationMenuItem implements DxNavigationTreeNodeDataProvider {
  @jsonMember({name: "id", constructor: Number, emitDefaultValue: true, isRequired: false})
  private _id: number = 0;

  @jsonMember({name: "parentId", constructor: Number, emitDefaultValue: false, isRequired: false})
  private _parentId: number;

  @jsonMember({name: "ownerId", constructor: Number, emitDefaultValue: true, isRequired: false})
  private _ownerId: number = 0;

  @jsonMember({name: "ord", constructor: Number, emitDefaultValue: true, isRequired: false})
  private _ord: number = 0;

  @jsonMember({name: "title", constructor: String, emitDefaultValue: true, isRequired: false})
  private _title: string;

  @jsonMember({name: "ident", constructor: String, emitDefaultValue: true, isRequired: false})
  private _ident: string;

  @jsonMember({name: "icon", constructor: String, emitDefaultValue: true, isRequired: false})
  private _icon: string;

  @jsonMember({name: "hint", constructor: String, emitDefaultValue: true, isRequired: false})
  private _hint: string;

  @jsonMember({name: "hasSubMenu", constructor: Boolean, emitDefaultValue: true, isRequired: false})
  private _hasSubMenu: boolean = false;

  @jsonMember({name: "route", constructor: String, emitDefaultValue: true, isRequired: false})
  private _route: string;

  @jsonMember({name: "involvedInRouting", constructor: Boolean, emitDefaultValue: true, isRequired: false})
  private _involvedInRouting: boolean = true;


  public getNodeHint(): string {
    return this._hint;
  }

  public getNodeIcon(): string {
    return this._icon;
  }

  public getNodeId(): number {
    return this._id;
  }

  public getNodeIdent(): string {
    return this._ident;
  }

  public getNodeOrd(): number {
    return this._ord;
  }

  public getNodeParentId(): number {
    return this._parentId;
  }

  public getNodeTitle(): string {
    return this._title;
  }

  public getNodeRoute(): string {
    return this._route;
  }

  public hasSubTree(): boolean {
    return this._hasSubMenu;
  }

  isInvolvedInRouting(): boolean {
    return this._involvedInRouting;
  }

  get id(): number {
    return this._id;
  }

  set id(value: number) {
    this._id = value;
  }

  get parentId(): number {
    return this._parentId;
  }

  set parentId(value: number) {
    this._parentId = value;
  }

  get ownerId(): number {
    return this._ownerId;
  }

  set ownerId(value: number) {
    this._ownerId = value;
  }

  get ord(): number {
    return this._ord;
  }

  set ord(value: number) {
    this._ord = value;
  }

  get title(): string {
    return this._title;
  }

  set title(value: string) {
    this._title = value;
  }

  get ident(): string {
    return this._ident;
  }

  set ident(value: string) {
    this._ident = value;
  }

  get icon(): string {
    return this._icon;
  }

  set icon(value: string) {
    this._icon = value;
  }

  get hint(): string {
    return this._hint;
  }

  set hint(value: string) {
    this._hint = value;
  }

  get hasSubMenu(): boolean {
    return this._hasSubMenu;
  }

  set hasSubMenu(value: boolean) {
    this._hasSubMenu = value;
  }

  get route(): string {
    return this._route;
  }

  set route(value: string) {
    this._route = value;
  }

  get involvedInRouting(): boolean {
    return this._involvedInRouting;
  }

  set involvedInRouting(value: boolean) {
    this._involvedInRouting = value;
  }
}
